import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import React from "react";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import { notifySomething } from "../_Utils/AppDocuCommon";
import CalibrationDialogForm from "./_CalibrationDialogForm";

export default class EditCalibrationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: null,
      loading: false,
      prevItemId: null,
    };
  }

  async componentDidMount() {
    if (this.props.itemId) {
      this.setState({ loading: true });
      try {
        const res = await AppDocuServiceCall.getCalibration(this.props.itemId);
        const cal = res.data.calibration || {};
        await new Promise(resolve => setTimeout(resolve, 500)); // sleep 500ms
        this.setState({ itemData: cal, loading: false, prevItemId: this.props.itemId });
      } catch (e) {
        this.setState({ loading: false });
        notifySomething('Errore caricamento dati calibrazione', 'error');
      }
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.itemId && this.props.itemId !== prevProps.itemId) {
      this.setState({ loading: true });
      try {
        const res = await AppDocuServiceCall.getCalibration(this.props.itemId);
        const cal = res.data.calibration || {};
        await new Promise(resolve => setTimeout(resolve, 500)); // sleep 500ms
        this.setState({ itemData: cal, loading: false, prevItemId: this.props.itemId });
      } catch (e) {
        this.setState({ loading: false });
        notifySomething('Errore caricamento dati calibrazione', 'error');
      }
    }
    // Reset state if dialog is closed
    if (!this.props.itemId && prevProps.itemId) {
      this.setState({ itemData: null, loading: false, prevItemId: null });
    }
  }

  updateCalibrationService = async (itemData) => {
    try {
      const res = await AppDocuServiceCall.updateCalibration(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error updating calibration', 'error');
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error updating calibration:', error);
      notifySomething('Error updating calibration', 'error');
    }
  };

  handleUpdate = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      name: m.name !== undefined && m.name !== null ? m.name : '',
      original_filename: m.original_filename !== undefined && m.original_filename !== null ? m.original_filename : '',
      ecu_type: m.ecu_type !== undefined && m.ecu_type !== null ? m.ecu_type : '',
      injector: m.injector !== undefined && m.injector !== null ? m.injector : '',
      fw_version: m.fw_version !== undefined && m.fw_version !== null ? m.fw_version : '',
      sw_version: m.sw_version !== undefined && m.sw_version !== null ? m.sw_version : '',
      usage_info: m.usage_info !== undefined && m.usage_info !== null ? m.usage_info : '',
      status: m.status !== undefined && m.status !== null ? m.status : '',
      com_brand: m.com_brand !== undefined && m.com_brand !== null ? m.com_brand : '',
    };
    await this.updateCalibrationService(data);
  }

  render() {
    const { itemData, loading } = this.state;
    return (
      <>
      {loading || !itemData ? (
        <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Edit Calibration</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}>
              <CircularProgress size={40} thickness={4} />
            </div>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Edit Calibration</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <CalibrationDialogForm
              itemData={itemData}
              onChange={newData => this.setState({ itemData: newData })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose}>Cancel</Button>
            <Button onClick={this.handleUpdate} color="primary" disabled={loading || !itemData}>Update</Button>
          </DialogActions>
        </Dialog>
      )}
      </>
    );
  }
}
